// Funciones auxiliares para modales y apartados de Granel Almacén

export const formatMagueyNombreComunPrimero = (magueyStr, catalog = []) => {
  if (!magueyStr || typeof magueyStr !== 'string') return "";
  const trimmed = magueyStr.trim();
  if (!trimmed) return "";

  const stripAccents = (str) =>
    (str || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim();

  const cleanTerm = stripAccents(trimmed);
  const catList = Array.isArray(catalog) ? catalog : [];

  const containsWord = (source, target) => {
    if (!source || !target) return false;
    const words = target.split(/\s+/).filter(w => w.length > 2 && w !== "maguey" && w !== "agave");
    if (words.length === 0) return source.includes(target);
    return words.every(w => source.includes(w));
  };

  const match = trimmed.match(/^([^(]+)\s*\(([^)]+)\)$/);
  if (match) {
    let p1 = match[1].trim();
    let p2 = match[2].trim();
    let commonPart = p1;
    let scientificPart = p2;

    if (p1.toLowerCase().includes("agave")) {
      commonPart = p2;
      scientificPart = p1;
    }

    const cleanCommon = stripAccents(commonPart);

    const matchedCat = catList.find(c => {
      const cComun = stripAccents(c.nombre_comun || c.nombreComun);
      return cComun && (cComun === cleanCommon || containsWord(cleanCommon, cComun) || containsWord(cComun, cleanCommon));
    });

    const cleanStr = (s) => (s || "").replace(/\s+/g, " ").trim();
    if (matchedCat && matchedCat.nombre_comun && matchedCat.nombre_cientifico) {
      return `${cleanStr(matchedCat.nombre_comun)} (${cleanStr(matchedCat.nombre_cientifico)})`;
    }

    return `${cleanStr(commonPart)} (${cleanStr(scientificPart)})`;
  }

  const cleanStr = (s) => (s || "").replace(/\s+/g, " ").trim();

  const exactCommonMatch = catList.find(c => {
    const cComun = stripAccents(c.nombre_comun || c.nombreComun);
    return cComun && cComun === cleanTerm;
  });
  if (exactCommonMatch && exactCommonMatch.nombre_comun && exactCommonMatch.nombre_cientifico) {
    return `${cleanStr(exactCommonMatch.nombre_comun)} (${cleanStr(exactCommonMatch.nombre_cientifico)})`;
  }

  const partialCommonMatch = catList.find(c => {
    const cComun = stripAccents(c.nombre_comun || c.nombreComun);
    return cComun && (containsWord(cleanTerm, cComun) || containsWord(cComun, cleanTerm));
  });
  if (partialCommonMatch && partialCommonMatch.nombre_comun && partialCommonMatch.nombre_cientifico) {
    return `${cleanStr(partialCommonMatch.nombre_comun)} (${cleanStr(partialCommonMatch.nombre_cientifico)})`;
  }

  if (cleanTerm.startsWith("agave")) {
    const scientMatch = catList.find(c => {
      const cCient = stripAccents(c.nombre_cientifico || c.nombreCientifico);
      return cCient && (cCient === cleanTerm || cleanTerm.includes(cCient));
    });
    if (scientMatch && scientMatch.nombre_comun && scientMatch.nombre_cientifico) {
      return `${cleanStr(scientMatch.nombre_comun)} (${cleanStr(scientMatch.nombre_cientifico)})`;
    }
  }

  return trimmed;
};
